<header class="relative flex h-12 w-full items-center justify-between gap-3 page-x">
  <button
    lButton
    bContent="icon"
    [bSize]="'small'"
    type="button"
    class="block text-text-400 lg:hidden"
    (click)="toggleMobileMenu()"
    aria-label="Abrir ou fechar menu"
  >
    <l-icon class="text-xl text-text-400" icon="menu" aria-hidden="true" />
  </button>

  <div class="flex flex-1"></div>

  <div class="flex items-center gap-2">
    <l-icon class="text-xl text-basic-400" icon="notifications" aria-hidden="true" />

    <div class="relative">
      <button
        type="button"
        class="flex cursor-pointer items-center justify-center gap-2 rounded-md border border-transparent p-1 transition-all duration-200 hover:border-primary-100 hover:bg-primary-500/8"
        [class.border-primary-200]="open()"
        [class.bg-primary-500/10]="open()"
        [attr.aria-expanded]="open()"
        aria-haspopup="menu"
        aria-label="Menu da conta"
        (click)="toggleUserMenu()"
      >
        <span
          class="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-primary-500/15 text-[11px] font-bold leading-none text-primary-600"
          [class.bg-primary-500]="open()"
          [class.text-basic-100]="open()"
        >
          {{ userInitial() }}
        </span>
        <l-text t="body3" tone="default" flow="inline-block" class="max-w-24 truncate">
          {{ me()?.name || 'Desconhecido' }}
        </l-text>
        <l-icon
          class="text-xl transition-colors duration-200"
          [class.text-primary-500]="open()"
          [class.text-text-400]="!open()"
          [icon]="open() ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
          aria-hidden="true"
        />
      </button>

      @if (open()) {
        <div
          class="user-menu-panel absolute right-0 top-[calc(100%+0.35rem)] z-50 w-[min(100vw-2rem,17rem)] overflow-hidden rounded-xl border border-primary-100 bg-basic-100 shadow-lg shadow-primary-500/10"
          role="menu"
          lOutsideClick
          (outsideClick)="closeUserMenu()"
        >
          <div class="bg-primary-500 px-4 py-3.5">
            <div class="flex items-center gap-3">
              <span
                class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-basic-100/15 text-sm font-bold text-basic-100 ring-1 ring-basic-100/25"
              >
                {{ userInitials() }}
              </span>
              <div class="min-w-0 flex-1">
                <l-text t="body2" tone="white" strong="bold" flow="block" class="truncate">
                  {{ me()?.name || 'Desconhecido' }}
                </l-text>
                <l-text t="body3" flow="block" class="mt-0.5 truncate text-primary-100/90">
                  {{ me()?.email || '—' }}
                </l-text>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-1 p-2">
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-2.5 rounded-lg px-2 py-2 text-left transition-colors hover:bg-primary-500/8"
              (click)="openProfile()"
            >
              <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary-500/10">
                <l-icon class="text-lg text-primary-500" icon="person" aria-hidden="true" />
              </span>
              <l-text t="body2" tone="default" strong="medium" flow="block">Meu perfil</l-text>
            </button>
            <button
              type="button"
              role="menuitem"
              class="flex w-full items-center gap-2.5 rounded-lg px-2 py-2 text-left transition-colors hover:bg-danger-500/8"
              (click)="logout()"
            >
              <span class="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-danger-500/10">
                <l-icon class="text-lg text-danger-500" icon="logout" aria-hidden="true" />
              </span>
              <l-text t="body2" tone="default" strong="medium" flow="block">Sair</l-text>
            </button>
          </div>

          <div class="border-t border-primary-100 bg-basic-200/50 px-3 py-2">
            <l-text t="body3" tone="muted" flow="block" class="text-center">Kyros · v1.0.0</l-text>
          </div>
        </div>
      }
    </div>
  </div>
</header>
